import React from 'react'
import { Link } from "react-router-dom";

import MouseScroll from "../../Components/Scroll/MouseScroll";

import { useTranslation } from "react-i18next";

import "./ExpoProgram.css?ver=1";

import background_img from "../../images/top_bg_01_2022_5.png";
import card_img from "../../images/cont_item_06.png";
import lecture_img from '../../images/program/openlecture2.png';
import nobel_img from "../../images/program/nobel3.jpg";
import job_img from "../../images/program/jobfair2.png";
import event_img from "../../images/program/handonevent.png";

const ExpoProgram = () => {
    const { t } = useTranslation();

  return (
    <div className='expo-program-container'>
        <div className='expo-img-container'>
            <img src={background_img} />
        </div>
        <div className='expo-program-title-container'>
            <p className='expo-program-title'>{t('expo_citizen_program_title')}</p>
            <p className='expo-program-title-desc'>{t('expo_citizen_program_title_desc')}</p>
        </div>
        <div className='expo-cards-container'>
            <Link to="/about/seminar" className='expo-program-card'>
                <div className='expo-program-card-img'>
                    <img src={lecture_img}/>
                </div>
                <div className='expo-program-card-content'>
                    <div className='expo-program-card-info'>
                        <p className='expo-program-card-title'>{t("expo_citizen_program_card1_title")}</p>
                        <div className='expo-program-card-desc'>
                            <p>{t("expo_citizen_program_card1_desc1")}</p>
                            <p>{t("expo_citizen_program_card1_desc2")}</p>
                        </div>
                    </div>
                </div>
            </Link>
            <Link to="about/event" className='expo-program-card'>
                <div className='expo-program-card-img'>
                    <img src={event_img} />
                </div>
                <div className='expo-program-card-content'>
                    <div className='expo-program-card-info'>
                        <p className='expo-program-card-title'>{t("expo_citizen_program_card2_title")}</p>
                        <div className='expo-program-card-desc'>
                            <p>{t("expo_citizen_program_card2_desc1")}</p>
                            <p>{t("expo_citizen_program_card2_desc2")}</p>
                        </div>
                    </div>
                </div>
            </Link>
            <Link to="/" className='expo-program-card'>
                <div className='expo-program-card-img'>
                    <img src={job_img} />
                </div>
                <div className='expo-program-card-content'>
                    <div className='expo-program-card-info'>
                        <p className='expo-program-card-title'>{t("expo_citizen_program_card3_title")}</p>
                        <div className='expo-program-card-desc'>
                            <p>{t("expo_citizen_program_card3_desc1")}</p>
                            <p>{t("expo_citizen_program_card3_desc2")}</p>
                        </div>
                    </div>
                </div>
            </Link>
            <Link to="/about/nobel" className='expo-program-card'>
                <div className='expo-program-card-img'>
                    <img src={nobel_img} />
                </div>
                <div className='expo-program-card-content'>
                    <div className='expo-program-card-info'>
                        <p className='expo-program-card-title'>{t("expo_citizen_program_card4_title")}</p>
                        <div className='expo-program-card-desc'>
                            <p>{t("expo_citizen_program_card4_desc1")}</p>
                            <p>{t("expo_citizen_program_card4_desc2")}</p>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
        <MouseScroll />
    </div>
  )
}

export default ExpoProgram